// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__9AeXo","popper":"styles_popper__M2jJc","arrow":"styles_arrow__MV-Re"};